@if (store.filters() && store.queryParams()) {
	<div
		class="w-screen h-screen overflow-y-auto bg-white lg:border-r lg:sticky lg:mr-10 lg:top-0 lg:w-76"
	>
		<aside class="px-4 pt-6 pb-20 lg:pt-0 lg:pl-0 lg:pr-10" id="filter-component">
			<div class="flex flex-col h-full" role="search">
				<div class="flex items-center justify-between">
					<p class="text-lg font-bold">Search & Filters</p>
					<!-- reset filter -->
					<button
						type="button"
						aria-expanded="false"
						aria-controls="filter-component"
						aria-label="Reset filters"
						(click)="resetFilters()"
						class="text-xs text-gray-500 border-b border-gray-500 lg:inline-block only-tab-focus hover:text-gray-700"
					>
						Reset filters
					</button>
					<!-- close filter -->
					<button
						(click)="closeFilter.emit(true)"
						aria-controls="filter-component"
						aria-label="Close filters"
						class="p-2 bg-gray-200 rounded-md lg:hidden"
					>
						<uc-close-modal-svg customStyles="stroke-gray-900" />
					</button>
				</div>

				<div class="w-full my-6 border-b border-gray-500"></div>

				<!-- filter pills -->
				@if (store.pills().length) {
					<div class="pb-6 space-y-2 lg:hidden">
						<span
							class="block pb-2 text-base font-medium text-gray-500 pointer-events-none"
							role="presentation"
						>
							Applied filters:
						</span>
						<div class="flex flex-wrap gap-x-2 gap-y-4">
							@for (pill of store.pills(); track $index) {
								<uc-filter-pill
									[pillLabel]="pill.label"
									[urlKey]="pill.urlKey"
									[urlValue]="pill.urlValue"
									[removeActionDisabled]="pill.removeActionDisabled"
									(removeFilter)="
										removePill($event.urlKey, $event.urlValue)
									"
								/>
							}
						</div>
						<div class="pt-2 pb-6 border-b border-gray-500">
							<button
								type="button"
								class="inline mb-2 text-xs text-gray-500 border-b border-gray-500 only-tab-focus hover:text-gray-700"
								(click)="resetFilters()"
							>
								Clear all filters
							</button>
						</div>
					</div>
				}

				<div class="flex flex-col w-full gap-3 pb-6 border-b border-gray-500">
					<!-- search -->
					<uc-filter-search
						class="block w-full"
						[searchTerm]="store.payload().name"
						(searchTermEntered)="onSearchTerm($event)"
					/>

					<!-- clearing checkbox-->
					@if (clearingEnabled()) {
						<div class="mt-3">
							<uc-clearing-checkbox
								[product]="store.product()"
								searchType="university"
								(changeClearingChecked)="onClearingSelect($event)"
							/>
						</div>
					}
				</div>

				<!-- STUDY LEVEL -->
				<uc-study-level-select
					class="py-6 border-b border-gray-500"
					[studyLevel]="product()"
					[description]="studyLevelCopy()"
					(studyLevelChange)="onStudyLevel($event)"
				/>

				<!-- location -->
				<uc-checkbox-select
					filterTitle="Location"
					fieldSetName="location"
					[numOfFilters]="store.payload().locationIds?.length || 0"
					[filterOptions]="store.filters().locations"
					(filterChanged)="updateQueryParams($event, 'loc')"
				/>
			</div>
		</aside>
	</div>
}
